import type { NavItem } from '../../types/navigation.types';

const toTitle = (slug: string): string =>
  slug
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
    .replace('Msi', 'MSI')
    .replace('Hp', 'HP')
    .replace('Nvme', 'NVMe')
    .replace('Cpu', 'CPU')
    .replace('Vga', 'VGA')
    .replace('Ups', 'UPS')
    .replace('Pc', 'PC');

const children = (slugs: string[]) => slugs.map((slug) => ({ label: toTitle(slug), slug }));

export const NAV_ITEMS: NavItem[] = [
  // { label: 'Home', basePath: '/' },
  {
    label: 'Laptop',
    basePath: '/laptop',
    slug: 'laptop',
    children: children(['asus', 'msi', 'dell', 'hp', 'apple', 'lenovo', 'acer', 'high-end-laptops', 'used-laptops']),
  },
  {
    label: 'Desktop PC',
    basePath: '/desktop',
    slug: 'desktop-pc',
    children: children(['office-pc', 'branded-pc-dell-hp', 'gaming-pc', 'used-pc']),
  },
  {
    label: 'Components',
    basePath: '/components',
    slug: 'components',
    children: children([
      'motherboard',
      'processor',
      'ram',
      'vga',
      'storage-hdd-ssd-nvme',
      'computer-casing',
      'cpu-cooler',
      'monitor',
      'power-supply',
      'cooling-lighting',
    ]),
  },
  {
    label: 'Accessories',
    basePath: '/accessories',
    slug: 'accessories',
    children: children([
      'laptop-accessories',
      'mouse',
      'keyboard',
      'gaming-chair',
      'webcam',
      'headphones',
      'speakers-subwoofers',
      'microphone',
      'printer-accessories',
      'ink-bottles',
      'toner-cartridges',
      'portable-storage',
      'cables',
      'dongle',
      'hard-disk-caddy',
      'memory-card',
      'pen-drive',
      'mouse-pad',
      'power-bank',
      'ups-ups-battery',
    ]),
  },
  {
    label: 'Printers',
    basePath: '/printers',
    slug: 'printers',
    children: children(['inkjet-printers', 'laser-printers', 'multi-function-printers']),
  },
  { label: 'Projectors', basePath: '/projectors', slug: 'projectors' },
  { label: 'CCTV', basePath: '/product-category/cctv-2', slug: 'cctv-2' },
  { label: 'POS System', basePath: '/pos-system', slug: 'pos-system' },
  { label: 'Software', basePath: '/software', slug: 'software' },
  {
    label: 'Used Items',
    basePath: '/used-items',
    slug: 'used-items',
    children: children(['used-laptops', 'used-desktops', 'used-accessories']),
  },
  { label: 'OFFERS', basePath: '/offers', hotBadge: true },
];

export const MOBILE_UTILITY_ITEMS = [
  { label: 'Cart', href: '/cart' },
  { label: 'Compare', href: '/comparison' },
];

export const toCategoryHref = (basePath: string, slug?: string): string =>
  slug ? `${basePath}/${slug}` : basePath;
